import intersection from 'lodash-es/intersection'

import CategoryPageContainer from '../../client/containers/categoryPageContainer'
import SearchPageContainer from '../../client/containers/searchPageContainer'
import { searchFrontendParams } from '../../common/constants/searchQueryWhitelist'
import { hasFeature } from '../../common/utils/features'
import pageExperimentContainer, {
  MapStateToPageComponent
} from '../containers/pageExperimentContainer/pageExperimentContainer'

const hasSearchPageQueryParams = (query: any) =>
  !!intersection(Object.keys(query), searchFrontendParams).length

const mapStateToPageComponent: MapStateToPageComponent = state => {
  const {
    experiments,
    common: { currentSite },
    router: { location }
  } = state

  if (hasFeature('categoryPage', currentSite, location, experiments)) {
    if (hasSearchPageQueryParams(location.query)) {
      return SearchPageContainer
    } else {
      return CategoryPageContainer
    }
  }
  return SearchPageContainer
}

const SearchCategoryPageProxyContainer = pageExperimentContainer(
  [SearchPageContainer, CategoryPageContainer],
  mapStateToPageComponent
)

export default SearchCategoryPageProxyContainer
